import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { ShareWeb } from '@one-thd/sui-icons';

const ShareAction = ({ onClick, iconSize }) => (
  <button
    className="sui-flex sui-items-center sui-gap-1 sui-cursor-pointer sui-bg-transparent sui-border-0 sui-p-0"
    data-testid="list-icon-text-action"
    onClick={onClick}
    aria-label="Share list"
    type="button"
  >
    <ShareWeb
      data-testid="share-icon"
      size={iconSize}
    />
    <div className="sui-gap-2 sui-hidden xl:@xl:sui-flex">
      <Typography decoration="underline">Share</Typography>
    </div>
  </button>
);

ShareAction.propTypes = {
  onClick: PropTypes.func,
  iconSize: PropTypes.string
};

ShareAction.defaultProps = {
  onClick: () => {},
  iconSize: null
};

export default ShareAction;